import * as types from '../types';

const INITIAL_STATE = {
  loading: false,
  loginError: false,
  messageError: '',
  isAuthenticated: false,
  user: null,
  token: null,
  tokenString: '',
  showLogin: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SIGN_IN_SUCCESS:
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.user,
        tokenString: action.payload.tokenString,
        isAuthenticated: true,
        loginError: false,
        messageError: '',
        loading: false,
      };
    case types.SIGN_IN_ERROR:
      return {
        ...state,
        user: null,
        isAuthenticated: false,
        loginError: true,
        messageError: action.payload.message,
        loading: false,
      };
    case types.SIGN_LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.SIGN_VALIDATE_TOKEN:
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.user,
        isAuthenticated: true,
        tokenString: action.payload.tokenString,
        loading: false,
      };
    case types.SIGN_OUT:
      return {
        ...state,
        user: null,
        isAuthenticated: false,
        loading: false,
      };
    case types.SHOW_LOGIN:
      return {
        showLogin: true,
      };
    case types.HIDE_LOGIN:
      return {
        showLogin: false,
      };
    default:
      return state;
  }
};
